export default "__VITE_ASSET__B6UJ_xFm__"